<template>
  <v-card elevation="0" class="person-form">
    <s-toolbar v-if="visibleTitle" label="Editar Persona" style="color: white" />

    <v-container fluid class="px-6 py-4">
      <!-- Datos Personales con Foto -->
      <v-card flat class="mb-6 personal-data-card">
        <v-card-title class="text-h6 font-weight-medium mb-4 px-0">
          <v-icon class="mr-2" color="primary">mdi-account-circle</v-icon>
          Datos Personales
        </v-card-title>

        <v-row no-gutters>
          <!-- Formulario de datos personales -->
          <v-col cols="12" md="8" class="pr-md-6">
            <!-- Tipo documento y número -->
            <v-row class="mb-3">
              <v-col cols="12" sm="3">
                <s-select-definition ref="typePersonDocumentRef" :def="1036" label="Tipo Documento"
                  v-model="TypePersonDocument" @keyupEnter="txtDocument()" returnObject @change="Limit()"
                  :add="$fun.isAdmin()" :readonly="propPerson !== null" outlined dense />
              </v-col>
              <v-col cols="12" sm="3">
                <s-text @keyupEnter="txtDocument()" label="Documento*" :readonly="propPerson !== null" number :rules="[
                  (v) => !!v || 'Campo obligatorio',
                  (v) =>
                    v.length >= TypePersonDocument.DedHelper2 ||
                    'Debe tener ' + TypePersonDocument.DedHelper2 + ' dígitos',
                ]" ref="document" v-model="person.GenPerson.PrsDocumentNumber" :max="getDocumentMaxValue()"
                  :maxlength="parseInt(TypePersonDocument.DedHelper2) || 8"
                  :counter="parseInt(TypePersonDocument.DedHelper2) || 8" :showCounter="true" outlined dense />
              </v-col>
              <template v-if="typeperson == 1">
                <v-col cols="12" sm="3">
                  <s-text ref="textNtpName" label="Nombres*" :rules="[
                    (v) => !!v || 'Campo obligatorio',
                    (v) => v.length >= 3 || 'Mínimo 3 caracteres',
                  ]" v-model.trim="person.NtpName" @input="handleInput($event)"
                    :autofocus="person.GenPerson.PrsDocumentNumber.length > 0" :uppercase="true" outlined dense />
                </v-col>
                <v-col cols="12" sm="3">
                  <s-text ref="textNtpPaternalSurname" label="Apellido Paterno*" :rules="[
                    (v) => !!v || 'Campo obligatorio',
                    (v) => v.length >= 3 || 'Mínimo 3 caracteres',
                  ]" v-model.trim="person.NtpPaternalSurname" @input="handleInputPat($event)" :uppercase="true"
                    outlined dense />
                </v-col>
                <v-col cols="12" sm="3">
                  <s-text ref="textNtpMaternalSurname" label="Apellido Materno*" :rules="[
                    (v) => !!v || 'Campo obligatorio',
                    (v) => v.length >= 3 || 'Mínimo 3 caracteres',
                  ]" v-model.trim="person.NtpMaternalSurname" @input="handleInputPat($event)" :uppercase="true"
                    outlined dense />
                </v-col>
              </template>
              <!-- Fecha, género, nacionalidad -->
              <v-col cols="12" sm="3">
                <s-date ref="birthDateRef" v-model="person.NtpBirthDate" label="Fecha Nacimiento" outlined dense />
              </v-col>
              <v-col cols="12" sm="3">
                <s-select-definition ref="typeSexRef" :def="1037" label="Género" v-model="person.TypeSex"
                  :add="$fun.isAdmin()" outlined dense />
              </v-col>
              <v-col cols="12" sm="3">
                <s-select-definition ref="natIdRef" :def="1502" label="Nacionalidad" v-model="person.NatID"
                  :add-custom="$fun.isAdmin()" :custom-fields="[
                    {
                      key: 'DedDescription',
                      label: 'Nombre del País',
                      required: true,
                      cols: 4,
                    },
                    {
                      key: 'DedAbbreviation',
                      label: 'Abreviación',
                      required: true,
                      cols: 2,
                    },
                    {
                      key: 'DedFormat',
                      label: 'Gentilicio',
                      required: true,
                      cols: 2,
                    },
                    {
                      key: 'DedHelper',
                      label: 'ScireID',
                      required: true,
                      cols: 2,
                    },
                    {
                      key: 'DedHelper2',
                      label: 'SunatID',
                      required: true,
                      cols: 2,
                    }
                  ]" outlined dense />
              </v-col>

              <v-col cols="12" sm="4">
                <v-switch label="Discapacitado(a)" v-model="person.NtpDisability" color="primary" dense
                  hide-details></v-switch>
              </v-col>
              <v-col cols="12" sm="4" v-if="person.NtpDisability">
                <v-file-input accept=".pdf,.jpg,.jpeg,.png" label="Anexo" v-model="Attach" @change="validateFile()"
                  :rules="[
                    (v) =>
                      (v && /\.(jpg|jpeg|png|pdf)$/i.test(v.name)) ||
                      'Debe ser imagen o PDF',
                  ]" outlined dense hide-details />
              </v-col>
              <v-col cols="12" sm="4" v-if="person.NtpDisability">
                <v-btn color="success" :disabled="!Attach" small @click="openFile(Attach)" class="mt-1">
                  <v-icon small class="mr-1">mdi-download</v-icon>
                  Ver Anexo
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4">
                <v-switch label="Sindicalizado(a)" v-model="person.NtpSyndical" color="primary" dense
                  hide-details></v-switch>
              </v-col>
              <!-- Nombre jurídico -->
              <template v-if="typeperson == 2">
                <v-col cols="12">
                  <s-text ref="textJrpName" label="Nombre Jurídico*" v-model="person.JrpName"
                    :autofocus="person.GenPerson.PrsDocumentNumber.length > 0" outlined dense />
                </v-col>
              </template>
            </v-row>
            <v-row> </v-row>
          </v-col>

          <!-- Sección de Foto -->
          <v-col cols="12" md="4">
            <v-card flat class="photo-section">
              <v-card-title class="text-subtitle-1 font-weight-medium px-0 pb-2">
                <v-icon small class="mr-1">mdi-camera</v-icon>
                Fotografía
              </v-card-title>

              <div class="d-flex flex-column align-center">
                <div class="photo-container mb-3">
                  <v-img v-show="image || !isCameraActive" :src="image ? image : '../../../public/static/User.png'"
                    class="photo-preview" width="200" height="240" contain />
                </div>

                <div class="d-flex flex-column ga-2">
                  <v-btn color="primary" @click="openCamera" outlined small block>
                    <v-icon small class="mr-1">mdi-camera</v-icon>
                    Abrir Cámara
                  </v-btn>
                  <v-btn color="success" @click="capturePhoto" :disabled="!isCameraActive" outlined small block>
                    <v-icon small class="mr-1">mdi-camera-enhance</v-icon>
                    Capturar
                  </v-btn>
                  <v-btn color="error" @click="closeCamera" :disabled="!isCameraActive" outlined small block>
                    <v-icon small class="mr-1">mdi-camera-off</v-icon>
                    Cerrar Cámara
                  </v-btn>
                </div>

                <!-- Video y Canvas ocultos -->
                <video v-show="isCameraActive" ref="video" style="display: none" width="200" height="240"
                  autoplay></video>
                <canvas ref="canvas" style="display: none"></canvas>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

      <!-- Botón para Huella Dactilar -->
      <v-card flat class="mb-6">
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn color="blue" large @click="showModal = true" outlined>
              <v-icon class="mr-2">mdi-fingerprint</v-icon>
              Gestionar Huellas Dactilares
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <!-- Tabs para información adicional -->
      <v-card flat>
        <v-tabs v-model="currentItem" background-color="transparent" color="primary" grow>
          <v-tab href="#Address">
            <v-icon small class="mr-1">mdi-map-marker</v-icon>
            Direcciones
          </v-tab>
          <v-tab href="#TelephoneEmail">
            <v-icon small class="mr-1">mdi-phone</v-icon>
            Contacto
          </v-tab>
          <v-tab href="#Driver">
            <v-icon small class="mr-1">mdi-card-account-details</v-icon>
            Brevete
          </v-tab>
          <v-tab href="#Education">
            <v-icon small class="mr-1">mdi-school</v-icon>
            Formación
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="currentItem" class="mt-4">
          <!-- Tab Direcciones -->
          <v-tab-item :value="'Address'">
            <v-card flat outlined>
              <v-card-title class="text-h6 font-weight-medium">
                <v-icon class="mr-2" color="primary">mdi-map-marker</v-icon>
                {{ CancelEditarA ? "Editar" : "Nueva" }} Dirección

                <v-spacer></v-spacer>

                <v-btn v-if="CancelEditarA" color="error" icon small @click="cancelItemDetail(0)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>

                <v-btn color="success" icon small @click="addItemDetail(0)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text>
                <v-row class="mb-3">
                  <v-col cols="12" sm="3">
                    <s-select-generic label="Departamento" itemvalue="GenHelper" v-model="DepartmentUbigeo" autocomplete
                      full :config="configDepartment" outlined dense />
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-select-generic label="Provincia" itemvalue="GenHelper" v-model="ProvinceUbigeo" autocomplete full
                      :config="configProvince" outlined dense />
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-select-generic itemvalue="GenHelper" v-model="DistrictUbigeo" label="Distrito" autocomplete
                      @updateData="updateDataDistrict()" full :config="configDistrict" outlined dense />
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-select-definition :def="1513" label="Zona" v-model="Zone" ref="ZoneRef" :add="$fun.isAdmin()"
                      outlined dense />
                  </v-col>
                </v-row>

                <v-row class="mb-3">
                  <v-col cols="12" sm="3">
                    <s-select-definition :def="1512" label="Tipo de Dirección" v-model="TypeAddress"
                      ref="TypeAddressRef" :add="$fun.isAdmin()" outlined dense />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <s-text ref="addressRef" v-model="address.PadAddress" label="Dirección" outlined dense />
                  </v-col>
                  <v-col cols="12" sm="5">
                    <s-text v-model="address.PadAddressReference" label="Referencia" outlined dense />
                  </v-col>
                </v-row>

                <v-data-table :headers="addressHeaders" :items="addressDetail"
                  :sort-by="['SecStatus', 'TypeAddress', 'PadID']" :sort-desc="[true]" class="elevation-1">
                  <template v-slot:[`item.PadIsDefault`]="{ item }">
                    <v-chip small :color="item.PadIsDefault == 1 ? 'primary' : 'default'">
                      {{ item.PadIsDefault == 1 ? "Principal" : "Opcional" }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.SecStatus`]="{ item }">
                    <v-chip small :color="item.SecStatus ? 'success' : 'grey'"
                      :text-color="item.SecStatus ? 'white' : 'black'">
                      {{ item.SecStatus ? "Activo" : "Inactivo" }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn icon small @click="editItem(item, 0)" color="primary">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon small @click="deleteItem(item, 0)" color="error">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- Tab Teléfono y Email -->
          <v-tab-item :value="'TelephoneEmail'">
            <v-row>
              <!-- Sección Teléfonos -->
              <v-col cols="12" md="6">
                <v-card flat outlined>
                  <v-card-title class="text-h6 font-weight-medium">
                    <v-icon class="mr-2" color="primary">mdi-phone</v-icon>
                    {{ CancelEditarT ? "Editar" : "Nuevo" }} Teléfono
                    <v-spacer></v-spacer>
                    <v-btn v-if="CancelEditarT" color="error" icon small @click="cancelItemDetail(1)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn color="success" icon small @click="addItemDetail(1)">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-row class="mb-3">
                      <v-col cols="12" sm="6">
                        <s-select-definition :def="1111" label="Tipo de Teléfono" v-model="phone.TypePhone"
                          ref="TypePhoneRef" :add="$fun.isAdmin()" outlined dense />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <s-text ref="phonePrimaryRef" v-model="phone.PpnNumberPhone" type="tel" number label="Número"
                          :maxlength="maxlengthPhone1" :counter="maxlengthPhone1 || 9" :showCounter="true" outlined
                          dense />
                      </v-col>
                    </v-row>

                    <v-data-table :headers="phonesHeaders" :items="filteredPhonesDetail" class="elevation-1">
                      <template v-slot:[`item.PpnIsDefault`]="{ item }">
                        <div class="d-flex align-center">
                          <v-btn icon small @click="setPhonePrincipal(item)">
                            <v-icon :color="item.PpnIsDefault == 1 ? 'amber' : 'grey'">
                              {{ item.PpnIsDefault == 1 ? 'mdi-star' : 'mdi-star-outline' }}
                            </v-icon>
                          </v-btn>
                          <span class="text-caption ml-1">
                            {{ item.PpnIsDefault == 1 ? "Principal" : "Opcional" }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-btn icon small @click="editItem(item, 1)" color="primary">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon small @click="deleteItem(item, 1)" color="error">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Sección Correos -->
              <v-col cols="12" md="6">
                <v-card flat outlined>
                  <v-card-title class="text-h6 font-weight-medium">
                    <v-icon class="mr-2" color="primary">mdi-email</v-icon>
                    {{ CancelEditarE ? "Editar" : "Nuevo" }} Correo
                    <v-spacer></v-spacer>
                    <v-btn v-if="CancelEditarE" color="error" icon small @click="cancelItemDetail(2)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn color="success" icon small @click="addItemDetail(2)">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-row class="mb-3">
                      <v-col cols="12" sm="6">
                        <s-text ref="emailPrimaryRef" label="Correo" v-model="email.PemEmail" :placeholder="'ejemplo'"
                          outlined dense />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <s-select-definition :def="1518" label="Dominio de Correo" v-model="email.TypeDomainEmail"
                          ref="TypeDomainEmailRef" :add="$fun.isAdmin()" outlined dense />
                      </v-col>
                    </v-row>

                    <v-data-table :headers="emailsHeaders" :items="filteredEmailsDetail" class="elevation-1">
                      <template v-slot:[`item.PemIsDefault`]="{ item }">
                        <div class="d-flex align-center">
                          <v-btn icon small @click="setEmailPrincipal(item)">
                            <v-icon :color="item.PemIsDefault == 1 ? 'amber' : 'grey'">
                              {{ item.PemIsDefault == 1 ? 'mdi-star' : 'mdi-star-outline' }}
                            </v-icon>
                          </v-btn>
                          <span class="text-caption ml-1">
                            {{ item.PemIsDefault == 1 ? "Principal" : "Opcional" }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:[`item.SecStatus`]="{ item }">
                        <v-chip small :color="item.SecStatus ? 'success' : 'grey'"
                          :text-color="item.SecStatus ? 'white' : 'black'">
                          {{ item.SecStatus ? "Activo" : "Inactivo" }}
                        </v-chip>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-btn icon small @click="editItem(item, 2)" color="primary">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon small @click="deleteItem(item, 2)" color="error">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- Tab Brevete -->
          <v-tab-item :value="'Driver'">
            <v-card flat outlined>
              <v-card-title class="text-h6 font-weight-medium">
                <v-icon class="mr-2" color="primary">mdi-card-account-details</v-icon>
                Licencia de Conducir
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="3">
                    <s-text v-model="driver.NpdDocumentNumber" label="N° Brevete" outlined dense />
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-select-definition :def="1139" label="Categoría" v-model="driver.TypeDocumentCategory"
                      :add="$fun.isAdmin()" outlined dense />
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-date v-model="driver.NpdDocumentInit" label="Fecha Emisión" outlined dense />
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-date v-model="driver.NpdDocumentEnd" label="Fecha Revalidación" outlined dense />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- Tab Formación -->
          <v-tab-item :value="'Education'">
            <v-card flat outlined>
              <v-card-title class="text-h6 font-weight-medium">
                <v-icon class="mr-2" color="primary">mdi-school</v-icon>
                Historial Académico
                <v-spacer></v-spacer>
                <v-btn color="success" icon small @click="openEducationModal()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-data-table :headers="educationHeaders" :items="majorsDetail" class="elevation-1">
                  <template v-slot:[`item.PmaIsDefault`]="{ item }">
                    <div class="d-flex align-center">
                      <v-btn icon small @click="setEducationPrincipal(item)">
                        <v-icon :color="item.PmaIsDefault == 1 ? 'amber' : 'grey'">
                          {{ item.PmaIsDefault == 1 ? 'mdi-star' : 'mdi-star-outline' }}
                        </v-icon>
                      </v-btn>
                      <span class="text-caption ml-1">
                        {{ item.PmaIsDefault == 1 ? "Principal" : "Opcional" }}
                      </span>
                    </div>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn icon small @click="editEducation(item)" color="primary" class="mr-2">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon small @click="deleteEducation(item)" color="error">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>

    <!-- Dialog para Agregar/Editar Educación -->
    <v-dialog v-model="educationDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          {{ isEditingEducation ? 'Editar Estudio' : 'Agregar Estudio' }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="educationForm">
            <v-row dense>
              <v-col cols="12" class="mb-3">
                <s-select-definition
                  ref="educLevelRef"
                  v-model="educationItem.LveID"
                  :def="1066"
                  label="Nivel Educativo obtenido*"
                  :addCustom="$fun.isAdmin()"
                    :customFields="[
                      {
                        key: 'DedDescription',
                        label: 'País',
                        required: true,
                        cols: 6,
                      },
                      {
                        key: 'DedFormat',
                        label: 'Gentilicio',
                        required: true,
                        cols: 6,
                      },
                      {
                        key: 'DedAbbreviation',
                        label: 'Abreviación',
                        required: true,
                        cols: 6,
                      },
                      {
                        key: 'DedHelper',
                        label: 'Cód. T4 Sunat',
                        required: true,
                        cols: 6,
                      },
                      {
                        key: 'DedHelper2',
                        label: 'Cód. T26 Sunat',
                        required: true,
                        cols: 6,
                      },
                    ]"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" class="mb-3" v-if="requiresInstitutionAndMajor">
                <s-select-educational-institution
                  ref="educInstitutionRef"
                  v-model="educationItem.EdiCode"
                  label="Institución Educativa*"
                  outlined
                  dense
                  @input="onInstitutionChange"
                />
              </v-col>
              <v-col cols="12" class="mb-3" v-if="requiresInstitutionAndMajor">
                <s-select-educational-major
                  ref="educMajorRef"
                  v-model="educationItem.EdmCode"
                  label="Carrera Profesional*"
                  :edi-code="educationItem.EdiCode"
                  :disabled="!educationItem.EdiCode"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" sm="6" class="mb-3">
                <s-text
                  type="number"
                  label="Año de Ingreso"
                  v-model="educationItem.PmaYearAdmission"
                  maxlength="4"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" sm="6" class="mb-3">
                <s-text
                  type="number"
                  label="Año de Egreso (o actual)"
                  v-model="educationItem.PmaYearGraduation"
                  maxlength="4"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="closeEducationModal()">Cancelar</v-btn>
          <v-btn color="success" text @click="saveEducationItem()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Huellas Dactilares -->
    <v-dialog v-model="showModal" max-width="800px" persistent>
      <v-card>
        <v-card-title class="text-h6 font-weight-medium" style="
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
          ">
          <v-icon class="mr-2" color="white">mdi-fingerprint</v-icon>
          Gestión de Huellas Dactilares
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="showModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <v-row justify="center" class="mb-4">
            <v-col cols="6" class="text-center">
              <h3 class="font-weight-medium">MANO IZQUIERDA</h3>
            </v-col>
            <v-col cols="6" class="text-center">
              <h3 class="font-weight-medium">MANO DERECHA</h3>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="12" class="text-center">
              <div style="position: relative; display: inline-block">
                <v-img lazy-src="@/assets/hands1.png" max-height="400" max-width="700" src="@/assets/hands1.png" />

                <div v-for="(finger, index) in fingers" :key="index" class="finger-point" :style="{
                  position: 'absolute',
                  top: finger.position.top,
                  left: finger.position.left,
                  backgroundColor:
                    selectedFinger === index
                      ? '#FF6B35'
                      : finger.isActive == true
                        ? '#4CAF50'
                        : 'rgba(255, 255, 255, 0.8)',
                  cursor: 'pointer',
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  color: selectedFinger === index || finger.isActive ? 'white' : '#333',
                  border: '2px solid #2C3E50',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                }" @mouseover="highlightFinger(index)" @mouseleave="resetHighlight" @click="selectFinger(index)"
                  @contextmenu.prevent="handleRightClick($event, index)">
                  {{ index + 1 }}
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- Instrucciones -->
          <v-row class="mt-4">
            <v-col cols="12" class="text-center">
              <v-alert type="info" outlined dense class="mb-0">
                <small>
                  <strong>Instrucciones:</strong> Haz clic en un dedo para capturar la
                  huella. Clic derecho para eliminar una huella existente.
                </small>
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal de Captura de Huella -->
    <v-dialog v-model="showCaptureModal" max-width="400px" persistent>
      <v-card>
        <v-card-title class="text-h6 text-center" style="
            background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%);
            color: white;
          ">
          {{ statusOpen ? "Capturando Huella" : "Huella Capturada" }}
        </v-card-title>

        <v-card-text class="text-center pa-6">
          <div class="fingerprint-scanner">
            <div v-if="scanning" class="scanner-container">
              <v-img src="@/assets/FingrPrint.png" alt="Fingerprint Icon" max-height="150" max-width="150"
                class="mx-auto fingerprint-icon" />
              <div class="scanner-overlay">
                <div class="scanner-line"></div>
              </div>
            </div>

            <div v-if="captured" class="captured-container">
              <img :src="capturedFingerprint" alt="Huella Capturada" class="captured-fingerprint" />
              <v-icon color="success" large class="success-icon">mdi-check-circle</v-icon>
            </div>

            <div v-if="!scanning && !captured" class="waiting-container">
              <v-icon color="grey" x-large>mdi-fingerprint</v-icon>
              <p class="mt-2 grey--text">Coloque el dedo en el sensor</p>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="justify-center pb-6">
          <v-btn v-if="!captured" color="grey darken-1" outlined @click="CloseFootprint">
            <v-icon small class="mr-1">mdi-close</v-icon>
            Cancelar
          </v-btn>

          <v-btn v-if="captured" color="success" @click="SaveFingerprint" class="mr-2">
            <v-icon small class="mr-1">mdi-content-save</v-icon>
            Guardar
          </v-btn>

          <v-btn v-if="captured" color="warning" outlined @click="RetakeFingerprint">
            <v-icon small class="mr-1">mdi-refresh</v-icon>
            Reintentar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Menu contextual -->
    <v-menu v-model="showContextMenu" :position-x="menuX" :position-y="menuY" absolute offset-y>
      <v-list dense>
        <v-list-item @click="deleteFingerprint" :disabled="!selectedFingerActive">
          <v-list-item-icon>
            <v-icon color="error">mdi-delete</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Eliminar huella</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-card>
</template>

<script>
import Service from "@/services/General/PersonService";
import _sGeneric from "@/services/General/GenericService";
import _sContracthmRs from "@/services/HumanResource/HmnContractService";
import _sHelper from "@/services/HelperService";
import SText from "@/components/Utils/SText.vue";
import _sGenUploadFiles from "@/services/General/GenUploadFiles";
import _sGenParam from "@/services/General/ParameterService";
import _sGeneral from "@/services/HelperService.js";
import _sAdmonition from "@/services/HumanResource/AdmonitionService";

export default {
  name: "ContractPersonAdd",
  components: { SText },
  props: {
    propPerson: {
      type: Object,
      default: null,
    },
    visibleTitle: {
      type: Boolean,
      default: true,
    },
    full: {
      type: Boolean,
      default: false,
    },
    typeperson: {
      type: Number,
      default: 1,
    },
    addTypeSex: {
      type: Boolean,
      default: false,
    },
    addBirthDate: {
      type: Boolean,
      default: false,
    },
    addDriver: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false, // Controla si el modal está visible
      scanning: false, // Bandera para saber si estamos en el proceso de escaneo
      captured: false, // Bandera para saber si la huella ha sido capturada correctamente
      editing: false,
      showCaptureModal: false,
      configNationality: null,
      statusOpen: false,
      configZones: null,
      TypeAddress: null,
      configDepartment: null,
      DepartmentUbigeo: "25",
      ProvinceUbigeo: "01",
      DistrictUbigeo: "20",
      item: 0,
      dataFingerL: {},
      Zone: null,
      referencEdit: null,
      editedIndexPhone: -1,
      editedIndexEmail: -1,
      editedIndexAddress: -1,
      currentTab: 0,
      currentItem: "tab-Funciones",
      isCameraActive: false, // Para saber si la cámara está activa
      itemsNationality: [],
      CancelEditarT: false,
      CancelEditarE: false,
      CancelEditarA: false,
      image: null,
      menu3: false,
      ipMatch: null,
      title: -1,
      config: {},
      dialog: false,
      capturedFingerprint: null,
      capturedFingerTemplate: null,
      dataIndexPrint: null,
      capturedFingerprints: Array(10).fill(null),
      showContextMenu: false,
      menuX: 0,
      menuY: 0,
      selectedFingerActive: false,
      selectedFingerDelete: null,
      validEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      fingers: [
        {
          id: 0,
          position: { top: "17%", left: "13%" },
          style: {},
          isActive: false,
        }, // Pulgar izquierdo
        {
          id: 1,
          position: { top: "10%", left: "18%" },
          style: {},
          isActive: false,
        }, // Índice izquierdo
        {
          id: 2,
          position: { top: "8%", left: "23%" },
          style: {},
          isActive: false,
        }, // Medio izquierdo
        {
          id: 3,
          position: { top: "10%", left: "29%" },
          style: {},
          isActive: false,
        }, // Anular izquierdo
        {
          id: 4,
          position: { top: "39%", left: "42%" },
          style: {},
          isActive: false,
        }, // Meñique izquierdo
        {
          id: 5,
          position: { top: "39%", left: "52%" },
          style: {},
          isActive: false,
        }, // Pulgar derecho
        {
          id: 6,
          position: { top: "10%", left: "65%" },
          style: {},
          isActive: false,
        }, // Índice derecho
        {
          id: 7,
          position: { top: "8%", left: "70%" },
          style: {},
          isActive: false,
        }, // Medio derecho
        {
          id: 8,
          position: { top: "10%", left: "76%" },
          style: {},
          isActive: false,
        }, // Anular derecho
        {
          id: 9,
          position: { top: "17%", left: "81%" },
          style: {},
          isActive: false,
        }, // Meñique derecho
      ],
      selectedFinger: null,
      address: {
        PadCodeUbigeo: "",
        PadAddress: "",
        PadAddressReference: "",
        PadDepartment: "",
        ZonID: 1,
        PadIsDefault: 1,
        TypeAddress: 1,
      },
      addressDefault: {
        PadCodeUbigeo: "",
        PadAddress: "",
        PadAddressReference: "",
        PadDepartment: "",
        ZonID: 1,
        PadIsDefault: 1,
        TypeAddress: 1,
      },
      phone: {
        PnpID: 0,
        TypePhone: 1,
        PpnNumberPhone: "",
        PpnIsDefault: 1,
        UsrCreateID: this.$fun.getUserID(),
      },
      phone2: {
        PnpID: 0,
        TypePhone: 1,
        PpnNumberPhone: "",
        PpnIsDefault: 2,
        UsrCreateID: this.$fun.getUserID(),
      },
      phoneDefault: {
        PnpID: 0,
        TypePhone: 1,
        PpnNumberPhone: "",
        PpnIsDefault: 2,
        UsrCreateID: this.$fun.getUserID(),
      },
      email: {
        PemID: 0,
        PemEmail: "",
        PemIsDefault: 1,
        TypeDomainEmail: 1,
        UsrCreateID: this.$fun.getUserID(),
      },
      email2: {
        PemID: 0,
        PemEmail: "",
        PemIsDefault: 2,
        TypeDomainEmail: 5,
        UsrCreateID: this.$fun.getUserID(),
      },
      emailDefault: {
        PemID: 0,
        PemEmail: "",
        PemIsDefault: 0,
        TypeDomainEmail: 1,
        UsrCreateID: this.$fun.getUserID(),
      },
      addressDetail: [],
      phonesDetail: [],
      emailsDetail: [],
      majorsDetail: [],
      educationDialog: false,
      isEditingEducation: false,
      educationItem: {
        PmaID: 0,
        LveID: null,
        EdiCode: null,
        EdiName: "",
        EdmCode: null,
        EdmName: "",
        PmaYearAdmission: null,
        PmaYearGraduation: null,
        PmaIsDefault: 0
      },
      educationHeaders: [
        { text: "Nivel", value: "LveName", sortable: false },
        { text: "Institución", value: "EdiName", sortable: false },
        { text: "Carrera", value: "EdmName", sortable: false },
        { text: "Ingreso", value: "PmaYearAdmission", sortable: false },
        { text: "Egreso", value: "PmaYearGraduation", sortable: false },
        { text: "Principal", value: "PmaIsDefault", sortable: false },
        { text: "Acciones", value: "actions", sortable: false }
      ],
      addressHeaders: [
        { text: "ID", value: "PadID", sortable: false, width: 20 },
        {
          text: "Distrito Ugigeo",
          value: "PadCodeUbigeo",
          sortable: false,
          width: 50,
        },
        { text: "Direccion", value: "PadAddress", sortable: false, width: 100 },
        //{ text: "Tipo de Dirección"   , value: "TypeAddress"            ,sortable:false   , width: 50,  },
        {
          text: "Tipo de Dirección",
          value: "TypeAddressName",
          sortable: false,
          width: 50,
        },
        {
          text: "Referencia",
          value: "PadAddressReference",
          sortable: false,
          width: 100,
        },
        //{ text: "Zona"                , value: "ZonID"                  ,sortable:false   , width: 70,  },
        { text: "Zona", value: "ZonName", sortable: false, width: 70 },
        {
          text: "Categoria",
          value: "PadIsDefault",
          sortable: false,
          width: 70,
        },
        { text: "Estado", value: "SecStatus", sortable: false, width: 70 },
        { text: "Acciones", value: "actions", sortable: false, width: 30 },
      ],
      phonesHeaders: [
        //{ text: "ID"                  , value: "PpnID"                 ,sortable: false  , width: 20,  },
        {
          text: "Tipo de Telfono",
          value: "TypePhoneName",
          sortable: false,
          width: 20,
        },
        {
          text: "Teléfono",
          value: "PpnNumberPhone",
          sortable: false,
          width: 20,
        },
        {
          text: "Categoria",
          value: "PpnIsDefault",
          sortable: false,
          width: 20,
        },
        { text: "Acciones", value: "actions", sortable: false, width: 30 },
      ],
      emailsHeaders: [
        //{ text: "ID"                  , value: "PemID"                 ,sortable: false  , width: 20,  },
        { text: "Correo", value: "PemEmail", sortable: false, width: 20 },
        {
          text: "Categoria",
          value: "PemIsDefault",
          sortable: false,
          width: 40,
        },
        { text: "Estado", value: "SecStatus", sortable: false, width: 40 },
        { text: "Acciones", value: "actions", sortable: false, width: 30 },
      ],
      person: {
        NtpName: "",
        NtpPaternalSurname: "",
        NtpMaternalSurname: "",
        NtpID: 0,
        NtpBirthDate: null,
        TypeSex: 1,
        GenPerson: {
          TypePersonDocument: 0,
          PrsDocumentNumber: "",
          NatID: 1,
          Telephones: "0",
        },
        GenNaturalPersonDriver: null,
        NtpDisability: 0,
        NtpSyndical: 0,
        NtpAttach: "",
      },
      driver: {
        NpdID: 0,
        NpdDocumentNumber: "",
        NtpID: 0,
        NpdDocumentInit: null,
        NpdDocumentEnd: null,
        TypeDocumentCategory: 0,
      },
      isInitializing: false, // Bandera para controlar la inicialización
      TypePersonDocument: 0,
      Attach: null,
      maxlengthPhone1: 9,
      maxlengthPhone2: 9,
      formats_accepted: ["image/jpeg", "image/jpg", "image/png", "application/pdf"],
      //3 mb
      max_size: 3000000,
      routeImage: null,
      paramName: "Ruta_Imagenes_RH",
      TypeAdmonitionName: "",
    };
  },
  methods: {
    getDocumentMaxValue() {
      const documentLength = Number(this.TypePersonDocument?.DedHelper2 || 0);

      if (documentLength <= 0) {
        return 99999999;
      }

      return Number("9".repeat(documentLength));
    },
    focusValidationField(refName, message, tab = null) {
      if (tab) {
        this.currentItem = tab;
      }

      this.$nextTick(() => {
        this.$fun.focusFieldError(this, refName, message);
      });
      this.$fun.alert(message, "warning");
    },
    hasAtLeastOneFingerprint() {
      return this.fingers.some(f => f.isActive);
    },
    hasActiveAddress() {
      return this.addressDetail.some((item) => item && item.SecStatus === 1 && item.PadIsDefault === 1);
    },
    hasPrincipalPhone() {
      return this.phonesDetail.some((item) => item && item.SecStatus === 1 && item.PpnIsDefault === 1);
    },
    hasPrincipalEmail() {
      return this.emailsDetail.some((item) => item && item.SecStatus === 1 && item.PemIsDefault === 1);
    },
    validateContractRequirements(silent = false) {
      const documentNumber = (this.person?.GenPerson?.PrsDocumentNumber || "").trim();
      const documentLength = Number(this.TypePersonDocument?.DedHelper2 || 0);
      const nationalId = this.person?.NatID || this.person?.GenPerson?.NatID || null;

      if (!this.TypePersonDocument || !this.TypePersonDocument.DedValue) {
        if (!silent) this.focusValidationField("typePersonDocumentRef", "Seleccione tipo de documento.");
        return false;
      }

      if (!documentNumber) {
        if (!silent) this.focusValidationField("document", "Registre el documento.");
        return false;
      }

      if (documentLength > 0 && documentNumber.length < documentLength) {
        if (!silent) this.focusValidationField(
          "document",
          `El documento debe tener ${documentLength} dígitos.`
        );
        return false;
      }

      if (this.typeperson === 1) {
        if (!(this.person.NtpName || "").trim()) {
          if (!silent) this.focusValidationField("textNtpName", "Registre nombres.");
          return false;
        }

        if ((this.person.NtpName || "").trim().length < 3) {
          if (!silent) this.focusValidationField("textNtpName", "Los nombres deben tener mínimo 3 caracteres.");
          return false;
        }

        if (!(this.person.NtpPaternalSurname || "").trim()) {
          if (!silent) this.focusValidationField("textNtpPaternalSurname", "Registre apellido paterno.");
          return false;
        }

        if (!(this.person.NtpMaternalSurname || "").trim()) {
          if (!silent) this.focusValidationField("textNtpMaternalSurname", "Registre apellido materno.");
          return false;
        }
      }

      if (!this.$fun.isValidDate(this.person.NtpBirthDate)) {
        if (!silent) this.focusValidationField("birthDateRef", "Registre una fecha de nacimiento válida.");
        return false;
      }

      if (!this.$fun.isValidAge(this.person.NtpBirthDate)) {
        if (!silent) this.focusValidationField(
          "birthDateRef",
          "La fecha de nacimiento debe corresponder a una edad válida entre 18 y 65 años."
        );
        return false;
      }

      if (!this.person.TypeSex) {
        if (!silent) this.focusValidationField("typeSexRef", "Seleccione género.");
        return false;
      }

      if (!nationalId) {
        if (!silent) this.focusValidationField("natIdRef", "Seleccione nacionalidad.");
        return false;
      }

      if (!this.hasActiveAddress()) {
        if (!silent) this.focusValidationField(
          "addressRef",
          "Debe registrar al menos una dirección principal (Categoría Principal) antes de continuar.",
          "Address"
        );
        return false;
      }

      if (!this.hasPrincipalPhone()) {
        if (!silent) this.focusValidationField(
          "phonePrimaryRef",
          "Debe registrar al menos un teléfono principal (Categoría Principal) antes de continuar.",
          "TelephoneEmail"
        );
        return false;
      }

      if (!this.hasPrincipalEmail()) {
        if (!silent) this.focusValidationField(
          "emailPrimaryRef",
          "Debe registrar al menos un correo principal (Categoría Principal) antes de continuar.",
          "TelephoneEmail"
        );
        return false;
      }

      // if (!this.hasAtLeastOneFingerprint()) {
      //   if (!silent) {
      //     this.$fun.alert("Debe registrar al menos una huella dactilar.", "warning");
      //     this.showModal = true;
      //   }
      //   return false;
      // }

      // if (!this.image) {
      //   if (!silent) {
      //     this.$fun.alert("Debe capturar o subir una fotografía.", "warning");
      //   }
      //   return false;
      // }

      return true;
    },
    async applyLoadedPerson(normalizedPropPerson) {
      const documentNumber = this.getResolvedDocumentNumber(normalizedPropPerson);

      if (documentNumber) {
        this.getImagePerson(documentNumber);
      }

      this.resetDetailCollections();

      const sourceAddresses =
        normalizedPropPerson?.GenPerson?.Addresses || normalizedPropPerson?.Addresses || [];
      const sourceTelephones =
        normalizedPropPerson?.GenPerson?.Telephones || normalizedPropPerson?.Telephones || [];
      const sourceEmails =
        normalizedPropPerson?.GenPerson?.Emails || normalizedPropPerson?.Emails || [];

      this.person = {
        ...this.person,
        ...normalizedPropPerson,
        PrsID: normalizedPropPerson.PrsID,
        PrsDocumentNumber: documentNumber,
        GenPerson: {
          ...(this.person.GenPerson || {}),
          ...(normalizedPropPerson.GenPerson || {}),
          PrsID: normalizedPropPerson.PrsID,
          PrsDocumentNumber: documentNumber,
          Addresses: sourceAddresses,
          Telephones: sourceTelephones,
          Emails: sourceEmails,
        },
      };

      this.person.NatID = normalizedPropPerson.GenPerson?.NatID || normalizedPropPerson.NatID || this.person.NatID;

      this.person.NtpDisability =
        normalizedPropPerson.GenNatutalPerson?.NtpDisability || normalizedPropPerson.NtpDisability || 0;
      this.person.NtpSyndical =
        normalizedPropPerson.GenNatutalPerson?.NtpSyndical || normalizedPropPerson.NtpSyndical || 0;
      this.Attach = normalizedPropPerson.GenNatutalPerson?.NtpAttach
        ? { name: normalizedPropPerson.GenNatutalPerson.NtpAttach }
        : null;

      this.driver = {
        NpdID: 0,
        NpdDocumentNumber: "",
        NtpID: 0,
        NpdDocumentInit: null,
        NpdDocumentEnd: null,
        TypeDocumentCategory: 0,
      };

      if (
        normalizedPropPerson.GenNatutalPerson &&
        normalizedPropPerson.GenNatutalPerson.GenNaturalPersonDriver &&
        normalizedPropPerson.GenNatutalPerson.GenNaturalPersonDriver.length > 0
      ) {
        this.driver.NpdDocumentNumber = normalizedPropPerson.GenNatutalPerson.GenNaturalPersonDriver[0].NpdDocumentNumber;
        this.driver.TypeDocumentCategory = normalizedPropPerson.GenNatutalPerson.GenNaturalPersonDriver[0].TypeDocumentCategory;
        this.driver.NpdDocumentInit = normalizedPropPerson.GenNatutalPerson.GenNaturalPersonDriver[0].NpdDocumentInit;
        this.driver.NpdDocumentEnd = normalizedPropPerson.GenNatutalPerson.GenNaturalPersonDriver[0].NpdDocumentEnd;
        this.driver.NpdID = normalizedPropPerson.GenNatutalPerson.GenNaturalPersonDriver[0].NpdID;
        this.driver.NtpID = normalizedPropPerson.NtpID;
        this.driver.SecStatus = normalizedPropPerson.GenNatutalPerson.GenNaturalPersonDriver[0].SecStatus;
        this.driver.UsrCreateID = normalizedPropPerson.GenNatutalPerson.GenNaturalPersonDriver[0].UsrCreateID;
        this.driver.UsrUpdateID = this.$fun.getUserID();
      }

      sourceAddresses.forEach((item) => {
        this.addressDetail.push({
          PadID: item.PadID,
          PrsID: normalizedPropPerson.PrsID,
          PadCodeUbigeo: item.PadCodeUbigeo,
          PadAddress: item.PadAddress,
          PadAddressReference: item.PadAddressReference,
          PadDepartment: item.PadDepartment,
          ZonID: item.ZonID,
          ZonName: item.ZonName,
          TypeAddress: item.TypeAddress,
          TypeAddressName: item.TypeAddressName,
          SecStatus: item.SecStatus,
          PadIsDefault: item.PadIsDefault,
          UsrCreateID: item.UsrCreateID,
          UsrUpdateID: this.$fun.getUserID(),
        });
      });

      this.phonesDetail = [];
      if (sourceTelephones.length > 0) {
        sourceTelephones.forEach((item) => {
          this.phonesDetail.push({
            PpnID: item.PpnID,
            PrsID: normalizedPropPerson.PrsID,
            TypePhone: item.TypePhone,
            TypePhoneName: item.TypePhoneName,
            PpnNumberPhone: item.PpnNumberPhone,
            SecStatus: item.SecStatus,
            PpnIsDefault: item.PpnIsDefault,
            UsrCreateID: item.UsrCreateID,
            UsrUpdateID: this.$fun.getUserID(),
          });
        });
      }

      this.emailsDetail = [];
      if (sourceEmails.length > 0) {
        sourceEmails.forEach((item) => {
          this.emailsDetail.push({
            PemID: item.PemID,
            PrsID: normalizedPropPerson.PrsID,
            PemEmail: item.PemEmail,
            SecStatus: item.SecStatus,
            PemIsDefault: item.PemIsDefault,
            TypeDomainEmail: item.TypeDomainEmail,
            UsrCreateID: item.UsrCreateID,
            UsrUpdateID: this.$fun.getUserID(),
          });
        });
      }

      this.majorsDetail = [];
      const sourceMajors = normalizedPropPerson?.Majors || [];
      if (sourceMajors.length > 0) {
        sourceMajors.forEach((item) => {
          this.majorsDetail.push({
            PmaID: item.PmaID,
            PrsID: normalizedPropPerson.PrsID,
            LveID: item.LveID,
            LveName: item.LveName,
            EdiCode: item.EdiCode,
            EdiName: item.EdiName,
            EdmCode: item.EdmCode,
            EdmName: item.EdmName,
            PmaYearAdmission: item.PmaYearAdmission,
            PmaYearGraduation: item.PmaYearGraduation,
            PmaIsDefault: item.PmaIsDefault,
            SecStatus: item.SecStatus,
            UsrCreateID: item.UsrCreateID,
            UsrUpdateID: this.$fun.getUserID(),
          });
        });
      }

      if (this.person.NtpID) {
        await this.GetFingerPrintListByNtpID();
      }
    },
    getResolvedPrsID(source = null) {
      const currentSource = source || this.person || {};

      return (
        currentSource.PrsID ||
        currentSource.GenPerson?.PrsID ||
        this.propPerson?.PrsID ||
        this.propPerson?.GenPerson?.PrsID ||
        0
      );
    },
    normalizePersonIds(source = null) {
      const currentSource = source || {};
      const prsID = this.getResolvedPrsID(currentSource);
      const prsDocumentNumber = this.getResolvedDocumentNumber(currentSource);

      return {
        ...currentSource,
        PrsID: prsID,
        PrsDocumentNumber: prsDocumentNumber,
        GenPerson: {
          ...(currentSource.GenPerson || {}),
          PrsID: prsID,
          PrsDocumentNumber: prsDocumentNumber,
        },
      };
    },
    getResolvedDocumentNumber(source = null) {
      const currentSource = source || this.person || {};

      return (
        currentSource.PrsDocumentNumber ||
        currentSource.GenPerson?.PrsDocumentNumber ||
        this.propPerson?.PrsDocumentNumber ||
        this.propPerson?.GenPerson?.PrsDocumentNumber ||
        ""
      );
    },
    shouldHydratePersonFromDocument(source = null) {
      const currentSource = source || {};
      const documentNumber = this.getResolvedDocumentNumber(currentSource);
      const hasCollections =
        Array.isArray(currentSource?.GenPerson?.Addresses) ||
        Array.isArray(currentSource?.GenPerson?.Telephones) ||
        Array.isArray(currentSource?.GenPerson?.Emails) ||
        Array.isArray(currentSource?.Addresses) ||
        Array.isArray(currentSource?.Telephones) ||
        Array.isArray(currentSource?.Emails);

      return !!documentNumber && (!this.getResolvedPrsID(currentSource) || !hasCollections);
    },
    async hydratePersonFromDocument(source = null) {
      const normalizedSource = this.normalizePersonIds(source || this.propPerson);
      const documentNumber = this.getResolvedDocumentNumber(normalizedSource);

      if (!documentNumber || !this.shouldHydratePersonFromDocument(normalizedSource)) {
        return normalizedSource;
      }

      try {
        const response = await Service.personatusearch(
          {
            TypePerson: 1,
            PrsDocumentNumber: documentNumber,
            UsrID: this.$fun.getUserID(),
            IsValidation: 0,
          },
          this.$fun.getUserID()
        );

        if (response?.status === 200 && response?.data) {
          return this.normalizePersonIds(response.data);
        }
      } catch (error) {
        console.error("Error al hidratar persona por documento:", error);
      }

      return normalizedSource;
    },
    resetDetailCollections() {
      this.addressDetail = [];
      this.phonesDetail = [];
      this.emailsDetail = [];
      this.majorsDetail = [];
      this.educationItem = {
        PmaID: 0,
        LveID: null,
        EdiCode: null,
        EdiName: "",
        EdmCode: null,
        EdmName: "",
        PmaYearAdmission: null,
        PmaYearGraduation: null,
        PmaIsDefault: 0
      };
      this.address = {
        ...this.addressDefault,
      };
      this.phone = {
        PnpID: 0,
        TypePhone: 1,
        PpnNumberPhone: "",
        PpnIsDefault: 1,
        UsrCreateID: this.$fun.getUserID(),
      };
      this.phone2 = {
        ...this.phoneDefault,
      };
      this.email = {
        PemID: 0,
        PemEmail: "",
        PemIsDefault: 1,
        TypeDomainEmail: 1,
        UsrCreateID: this.$fun.getUserID(),
      };
      this.email2 = {
        ...this.emailDefault,
        PemIsDefault: 2,
        TypeDomainEmail: 5,
      };
      this.driver = {
        NpdID: 0,
        NpdDocumentNumber: "",
        NtpID: 0,
        NpdDocumentInit: null,
        NpdDocumentEnd: null,
        TypeDocumentCategory: 0,
      };
    },
    handleInput(event) {
      this.person.NtpName = this.person.NtpName.trim();
    },
    handleInputPat(event) {
      this.person.NtpPaternalSurname = this.person.NtpPaternalSurname.trim();
    },
    handleInputMat(event) {
      this.person.NtpMaternalSurname = this.person.NtpMaternalSurname.trim();
    },
    changeAddress(item) {
      this.TypeAddress = item;
    },
    highlightFinger(index) {
      this.selectedFinger = index;
    },
    resetHighlight() {
      this.selectedFinger = null;
    },
    async selectFinger(index) {
      // console.log("eee",this.person.GenPerson.PrsDocumentNumber);
      if (
        this.person.GenPerson.PrsDocumentNumber !== null &&
        this.person.GenPerson.PrsDocumentNumber !== ""
      ) {
        // console.log('Huella seleccionada:', index);
        // this.CaptureFootprint();
        this.showModal = true;
        this.captured = false; // Resetear la bandera de captura
        this.scanning = true;
        this.capturedFingerprint = "";
        this.dataIndexPrint = index;
        await this.initializeDevice(index);
      } else {
        this.$fun.alert("Completar campos obligatorios", "warning");
      }
    },
    deleteItem(item, detail) {
      switch (detail) {
        case 0:
          if (item.PadID > 0) {
            const address = this.addressDetail.find((addr) => addr.PadID === item.PadID);
            if (address) {
              address.SecStatus = 0; // Cambiar el estado
              address.PadIsDefault = 2;
            }
          } else {
            this.editedIndexAddress = this.addressDetail.indexOf(item);
            this.addressDetail.splice(this.editedIndexAddress, 1);
            this.editedIndexAddress = -1;
          }
          break;
        case 1:
          if (item.PpnID > 0) {
            const phones = this.phonesDetail.find((addr) => addr.PpnID === item.PpnID);
            if (phones) {
              phones.SecStatus = 0; // Cambiar el estado
              phones.PpnIsDefault = 2;
            }
          } else {
            this.editedIndexPhone = this.phonesDetail.indexOf(item);
            this.phonesDetail.splice(this.editedIndexPhone, 1);
            this.editedIndexPhone = -1;
          }
          break;
        case 2:
          if (item.PemID > 0) {
            const emails = this.emailsDetail.find((addr) => addr.PemID === item.PemID);
            if (emails) {
              emails.SecStatus = 0; // Cambiar el estado
              emails.PemIsDefault = 2;
            }
          } else {
            this.editedIndexEmail = this.emailsDetail.indexOf(item);
            this.emailsDetail.splice(this.editedIndexEmail, 1);
            this.editedIndexEmail = -1;
          }
          break;
        default:
          break;
      }
    },

    editItem(item, detail) {
      this.isInitializing = true;

      switch (detail) {
        case 0:
          this.editedIndexAddress = this.addressDetail.indexOf(item);
          this.address = { ...item };
          this.TypeAddress = item.TypeAddress;
          this.Zone = item.ZonID;
          this.CancelEditarA = true;
          this.updateUbigeo(item.PadCodeUbigeo);
          break;
        case 1:
          this.editedIndexPhone = this.phonesDetail.indexOf(item);
          this.phone = { ...item };
          this.CancelEditarT = true;
          break;
        case 2:
          this.editedIndexEmail = this.emailsDetail.indexOf(item);
          this.email = { ...item };
          if (item && item.PemEmail) {
            this.email.PemEmail = item.PemEmail.split("@")[0];
          } else {
            this.email.PemEmail = "";
          }
          this.CancelEditarE = true;
          break;
        default:
          this.CancelEditarA = false;
          this.CancelEditarT = false;
          this.CancelEditarE = false;
          break;
      }
    },

    async updateUbigeo(ubigeo) {
      const department = ubigeo.substr(0, 2);
      const province = ubigeo.substr(2, 2);
      const district = ubigeo.substr(4, 2);

      this.DepartmentUbigeo = department;
      await this.updateProvinces(department, province);
      this.ProvinceUbigeo = province;
      await this.updateDistricts(province, district);
      this.DistrictUbigeo = district;
      this.$nextTick(() => {
        this.isInitializing = false; // Reactiva el watch después de inicializar
      });
    },

    async updateProvinces(department, province) {
      this.loadingProvinces = true;
      try {
        this.ProvinceUbigeo = province;
        this.configProvince = {
          title: "Provincia",
          url: _sGeneric.getProvince(),
          params: {
            requestID: this.$fun.getUserID(),
            DepartmentUbigeo: department,
            SearchText: "",
          },
        };
      } catch (error) {
        console.error("Error al cargar distritos:", error);
      } finally {
        this.loadingDistricts = false;
      }
    },

    async updateDistricts(province, district) {
      this.loadingDistricts = true;
      try {
        this.DistrictUbigeo = district;
        this.configDistrict = {
          title: "Distrito",
          url: _sGeneric.getDistrict(),
          params: {
            requestID: this.$fun.getUserID(),
            DistrictUbigeo: this.DepartmentUbigeo.toString() + province,
            SearchText: "",
          },
        };
      } catch (error) {
        console.error("Error al cargar distritos:", error);
      } finally {
        this.loadingProvinces = false;
      }
    },
    cancelItemDetail(valor) {
      this.clearDetail(valor);
    },
    validateDetail(detail) {
      let valid = true;
      let message = "";
      switch (detail) {
        case 0:
          if (!this.address.PadAddress) {
            this.focusValidationField("addressRef", "El campo Dirección es obligatorio", "Address");
            return false;
          }
          break;
        case 1:
          if (!this.phone.PpnNumberPhone) {
            this.focusValidationField("phonePrimaryRef", "El campo Teléfono no puede ser vacío", "TelephoneEmail");
            return false;
          }
          const requiredLength = this.maxlengthPhone1 || 9;
          if (this.phone.PpnNumberPhone.length < requiredLength) {
            this.focusValidationField(
              "phonePrimaryRef",
              `El número de Teléfono no puede ser menor de ${requiredLength} dígitos`,
              "TelephoneEmail"
            );
            return false;
          }
          break;
        case 2:
          if (!this.email.PemEmail) {
            this.focusValidationField("emailPrimaryRef", "El campo Email no puede ser vacío", "TelephoneEmail");
            return false;
          }
          break;
        default:
          break;
      }

      if (message) {
        this.$fun.alert(message, "warning");
        valid = false;
      }

      return valid;
    },
    setPhonePrincipal(item) {
      this.phonesDetail.forEach((p) => {
        if (p.SecStatus === 1) {
          p.PpnIsDefault = (p === item) ? 1 : 2;
          if (p.PpnID > 0) {
            p.UsrUpdateID = this.$fun.getUserID();
          }
        }
      });
      this.phonesDetail = [...this.phonesDetail];
    },
    setEmailPrincipal(item) {
      this.emailsDetail.forEach((e) => {
        if (e.SecStatus === 1) {
          e.PemIsDefault = (e === item) ? 1 : 2;
          if (e.PemID > 0) {
            e.UsrUpdateID = this.$fun.getUserID();
          }
        }
      });
      this.emailsDetail = [...this.emailsDetail];
    },
    addItemDetail(detail) {
      if (!this.validateDetail(detail)) {
        return;
      }

      const prsID = this.getResolvedPrsID();

      switch (detail) {
        case 0:
          let address = {
            PadID: this.address.PadID || 0,
            PrsID: prsID,
            PadCodeUbigeo:
              this.DepartmentUbigeo + this.ProvinceUbigeo + this.DistrictUbigeo,
            PadAddress: this.address.PadAddress,
            PadAddressReference: this.address.PadAddressReference,
            PadDepartment: "",
            ZonID: this.Zone ? this.Zone : 1,
            ZonName: this.$refs.ZoneRef.items.find((x) => x.DedValue === this.Zone)
              .DedDescription,
            TypeAddress: this.TypeAddress ? this.TypeAddress : 3,
            TypeAddressName: this.$refs.TypeAddressRef.items.find(
              (x) => x.DedValue === this.TypeAddress
            ).DedDescription,
            SecStatus: 1,
            PadIsDefault: this.TypeAddress == 1 ? 1 : 2,
            UsrCreateID: this.address.UsrCreateID || this.$fun.getUserID(),
            UsrUpdateID: this.address.PadID ? this.$fun.getUserID() : 0,
          };

          const itemAddress = this.addressDetail.find(
            (element) =>
              element.TypeAddress === 1 &&
              element.SecStatus == 1 &&
              this.addressDetail.indexOf(element) != this.editedIndexAddress
          );
          if (itemAddress && itemAddress.TypeAddress == this.TypeAddress) {
            let indexItemAddress = this.addressDetail.indexOf(itemAddress);

            if (itemAddress.PadID > 0) {
              itemAddress.SecStatus = 0;
              itemAddress.PadIsDefault = 2;
            } else {
              this.addressDetail.splice(indexItemAddress, 1);
            }
          }

          if (this.editedIndexAddress > -1) {
            Object.assign(this.addressDetail[this.editedIndexAddress], address);
          } else {
            this.addressDetail.push(address);
          }
          break;
        case 1:
          const isFirstActivePhone = !this.phonesDetail.some(p => p.SecStatus === 1);
          let phoneItem = {
            PpnID: this.phone.PpnID || 0,
            PrsID: prsID,
            TypePhone: this.phone.TypePhone,
            TypePhoneName: this.$refs.TypePhoneRef.items.find(
              (x) => x.DedValue === this.phone.TypePhone
            ).DedDescription,
            PpnNumberPhone: this.phone.PpnNumberPhone,
            SecStatus: 1,
            PpnIsDefault: this.phone.PpnIsDefault || (isFirstActivePhone ? 1 : 2),
            UsrCreateID: this.phone.UsrCreateID || this.$fun.getUserID(),
            UsrUpdateID: this.phone.PpnID ? this.$fun.getUserID() : 0,
          };

          if (this.editedIndexPhone > -1) {
            Object.assign(this.phonesDetail[this.editedIndexPhone], phoneItem);
          } else {
            this.phonesDetail.push(phoneItem);
          }
          if (phoneItem.PpnIsDefault === 1) {
            this.phonesDetail.forEach((p, idx) => {
              if (p.SecStatus === 1 && idx !== (this.editedIndexPhone > -1 ? this.editedIndexPhone : this.phonesDetail.length - 1)) {
                p.PpnIsDefault = 2;
                if (p.PpnID > 0) p.UsrUpdateID = this.$fun.getUserID();
              }
            });
          }
          break;
        case 2:
          const isFirstActiveEmail = !this.emailsDetail.some(e => e.SecStatus === 1);
          let rawEmail = (this.email.PemEmail || "").split("@")[0];
          let domainObj = this.$refs.TypeDomainEmailRef.items.find(
            (x) => x.DedValue === this.email.TypeDomainEmail
          );
          let emailDomain = domainObj ? domainObj.DedDescription : "";
          let emailItem = {
            PemID: this.email.PemID || 0,
            PrsID: prsID,
            PemEmail: rawEmail + emailDomain,
            SecStatus: 1,
            PemIsDefault: this.email.PemIsDefault || (isFirstActiveEmail ? 1 : 2),
            TypeDomainEmail: this.email.TypeDomainEmail,
            UsrCreateID: this.email.UsrCreateID || this.$fun.getUserID(),
            UsrUpdateID: this.email.PemID ? this.$fun.getUserID() : 0,
          };

          if (this.editedIndexEmail > -1) {
            Object.assign(this.emailsDetail[this.editedIndexEmail], emailItem);
          } else {
            this.emailsDetail.push(emailItem);
          }
          if (emailItem.PemIsDefault === 1) {
            this.emailsDetail.forEach((e, idx) => {
              if (e.SecStatus === 1 && idx !== (this.editedIndexEmail > -1 ? this.editedIndexEmail : this.emailsDetail.length - 1)) {
                e.PemIsDefault = 2;
                if (e.PemID > 0) e.UsrUpdateID = this.$fun.getUserID();
              }
            });
          }
          break;
        default:
          break;
      }

      this.clearDetail(detail);
    },

    clearDetail(detail) {
      switch (detail) {
        case 0:
          this.editedIndexAddress = -1;
          this.address = { ...this.addressDefault };
          this.DepartmentUbigeo = "20";
          this.ProvinceUbigeo = "01";
          this.DistrictUbigeo = "01";
          this.TypeAddress = 2;
          this.Zone = 4;
          this.CancelEditarA = false;
          break;
        case 1:
          this.editedIndexPhone = -1;
          this.phone = {
            PpnID: 0,
            TypePhone: 1,
            PpnNumberPhone: "",
            PpnIsDefault: 2,
            UsrCreateID: this.$fun.getUserID(),
          };
          this.CancelEditarT = false;
          break;
        case 2:
          this.editedIndexEmail = -1;
          this.email = {
            PemID: 0,
            PemEmail: "",
            PemIsDefault: 2,
            TypeDomainEmail: 1,
            UsrCreateID: this.$fun.getUserID(),
          };
          this.CancelEditarE = false;
          break;
        default:
          break;
      }
    },

    initialize() { },
    async initializeDevice(index) {
      let obj = {
        WftID: 0,
        DNI: this.person.GenPerson.PrsDocumentNumber,
        WftStatus: 1,
        WfpTypeFinger: index,
        UsrCreateID: this.$fun.getUserID(),
        NtpValue: "",
      };
      // console.log("obj", this.person);
      this.showCaptureModal = true;
      setTimeout(() => {
        this.statusOpen = true;
      }, 500);
      await _sContracthmRs
        .InitialFingerprint(obj, this.$fun.getUserID())
        .then((response) => {
          this.captured = true;
          this.scanning = false;
          this.statusOpen = false;

          // console.log(response);

          //this.GetFingerPrintListBy();

          // console.log("msg",response.data.data.image.length);
          // console.log("template",response.data.data.template);
          this.capturedFingerprint = "data:image/png;base64," + response.data.data.image;
          this.capturedFingerTemplate = response.data.data.template;
        })
        .catch((error) => {
          console.error("Error initializing device:", error);
        });
    },
    // CaptureFootprint(){
    //   this.scanning = true;
    //   _sContracthmRs.captureFingerprint()
    //   .then(fingerprintData => {

    //       // Do something with the fingerprint data (e.g., show it on screen)
    //     console.log("Captured fingerprint:", fingerprintData.fingerprintBase64);
    //     // Finalizar la animación de escaneo
    //     this.scanning = false;

    //     // Mostrar el icono de check verde para indicar éxito
    //     this.captured = true;
    //   })
    //   .catch(error => {
    //       // Handle error
    //       this.scanning = false;  // Detener la animación
    //       alert('No se pudo capturar la huella');
    //   });
    // },
    GetFingerPrintListBy() {
      if (
        this.person.GenPerson.PrsDocumentNumber !== null &&
        this.person.GenPerson.PrsDocumentNumber !== ""
      ) {
        _sContracthmRs
          .FingerPrintListBy(
            this.person.GenPerson.PrsDocumentNumber,
            this.$fun.getUserID()
          )
          .then((r) => {
            if (r.status == 200) {
              // console.log("fingeDATA: ",r.data);
              this.dataFingerL = r.data;
              this.dataFingerL.forEach((item) => {
                // Comparamos el id del dedo con el WfpTypeFinger
                this.fingers.forEach((finger) => {
                  if (finger.id === item.WfpTypeFinger) {
                    // Si coincide, cambiamos el estado de isActive a true
                    finger.isActive = true;
                  }
                });
              });
            }
          });
      }
    },
    GetFingerPrintListByNtpID() {
      if (this.person.NtpID !== null && this.person.NtpID !== 0) {
        return _sContracthmRs
          .FingerprintByNtp(this.person.NtpID, this.$fun.getUserID())
          .then((r) => {
            if (r.status == 200) {
              // console.log("fingeDATA: ",r.data);
              this.dataFingerL = r.data;
              this.dataFingerL.forEach((item) => {
                // Comparamos el id del dedo con el WfpTypeFinger
                this.fingers.forEach((finger) => {
                  if (finger.id === item.WfpTypeFinger) {
                    // Si coincide, cambiamos el estado de isActive a true
                    finger.isActive = true;
                  }
                });
              });
            }
          });
      }
      return Promise.resolve();
    },
    async CloseFootprint() {
      // await _sContracthmRs
      //   .closefingerprint(this.$fun.getUserID())
      //   .then((response) => {

      //     if(response.data.success == false){
      //       this.$fun.alert("Ocurrio un error al cerrar la conexión", "success");
      //     }

      //       console.log("response", response);
      //       this.showModal = false;
      //       this.captured = false;
      //       this.scanning = false;
      //       this.statusOpen = false;

      //   })
      //   .catch((error) => {
      //     console.error("Error:", error);
      //   });
      this.showCaptureModal = false;
      this.captured = false;
      this.scanning = false;
      this.statusOpen = false;
      this.capturedFingerprint = null;
      this.capturedFingerTemplate = null;
    },
    async RetakeFingerprint() {
      //console.log("RetakeFingerprint", this.dataIndexPrint);
      await this.selectFinger(this.dataIndexPrint);
    },
    SaveFingerprint() {
      // Guarda la huella en el array usando el índice del dedo
      this.capturedFingerprints[this.dataIndexPrint] = {
        NtpValue: this.capturedFingerTemplate,
        Image: this.capturedFingerprint,
        Dni: this.person.GenPerson.PrsDocumentNumber,
        WfpTypeFinger: this.dataIndexPrint,
        usrCreateID: this.$fun.getUserID(),
        SecStatus: 1,
      };

      // Marca el dedo como activo (cambia el color)
      this.fingers[this.dataIndexPrint].isActive = true;

      // Cierra solo el modal pequeño de captura
      this.showCaptureModal = false;
      this.captured = false;
      this.scanning = false;
      this.statusOpen = false;

      // Muestra confirmación al usuario
      this.$fun.alert("Huella capturada con exito", "success");
      //console.log("this.capturedFingerprints", this.capturedFingerprints);
    },
    // Método para abrir la cámara
    openCamera() {
      navigator.mediaDevices
        .getUserMedia({ video: { width: 640, height: 480 } }) // Resolución baja
        .then((stream) => {
          this.$refs.video.srcObject = stream; // Asignar el stream al elemento <video>
          this.$refs.video.style.display = "block"; // Mostrar el video en la interfaz
          this.$refs.video.play(); // Reproducir video
          this.isCameraActive = true; // Indicar que la cámara está activa
        })
        .catch((err) => {
          console.error("Error al acceder a la cámara: ", err);
          this.isCameraActive = false;
        });
    },
    // Método para cerrar la cámara
    closeCamera() {
      const video = this.$refs.video;
      if (video && video.srcObject) {
        const stream = video.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
        video.srcObject = null;
      }
      this.isCameraActive = false;
      if (video) {
        video.style.display = "none";
      }
    },
    // Método para capturar la foto desde el video
    capturePhoto() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");

      // Asegurarnos que el canvas tiene el mismo tamaño que el video
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      // Dibujar el fotograma actual del video en el canvas
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convertir la imagen a base64
      const dataUrl = canvas.toDataURL("image/png");

      // Asignar la imagen capturada al estado `image`
      this.image = dataUrl;

      // Detener la cámara
      const stream = video.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      video.srcObject = null;
      this.isCameraActive = false;

      // Subir la imagen al servidor
      this.uploadImage(dataUrl);
    },
    uploadImage(imageData) {
      if (!imageData) {
        this.$fun.alert("Sin archivo para subir");
        return;
      }

      // var formData = new FormData();

      // // Convertir base64 a Blob correctamente
      // const byteString = atob(imageData.split(',')[1]);
      // const mimeString = imageData.split(',')[0].split(':')[1].split(';')[0]; // Extraer el MIME type
      // const arrayBuffer = new ArrayBuffer(byteString.length);
      // const uintArray = new Uint8Array(arrayBuffer);

      // for (let i = 0; i < byteString.length; i++) {
      //     uintArray[i] = byteString.charCodeAt(i);
      // }

      // const file = new Blob([uintArray], { type: mimeString });

      // formData.append('file', file, 'photo.jpg');
      // formData.append('nameFile', this.person.GenPerson.PrsDocumentNumber);
      // formData.append('genParameter', this.paramName);

      _sGenUploadFiles
        .upload(imageData, this.person.GenPerson.PrsDocumentNumber, this.paramName, true)
        .then((resp) => {
          if (resp.status === 200) {
            this.$fun.alert("Imagen subida correctamente", "success");
          }
        })
        .catch((error) => {
          console.error("Error al subir la imagen: ", error);
        });
    },

    getParam() {
      return _sGenParam
        .search({ PrmName: this.paramName }, this.$fun.getUserID())
        .then((resp) => {
          if (resp.status == 200) {
            // console.log("resp.data:", resp.data)
            this.routeImage = resp.data.PrmValue;
            //console.log("this.milimetrosSpacing", this.routeImage)
          }
        });
    },
    async getImagePerson(documents) {
      // _sHelper
      // console.log("Ruta de Image",this.routeImage);
      // console.log("Documento",documents);
      // console.log("Parametro",this.paramName);
      await _sGenUploadFiles
        .getFile(this.paramName, documents, true)
        .then((rsp) => {
          // console.log("imagee1111",rsp);
          if (rsp) this.image = rsp;
          // else{
          //   _sGenUploadFiles
          //     .getFile(this.paramName,User,true)
          //       .then((rsp) => {
          //         console.log("imagee22222",rsp);
          //         if(rsp)
          //         this.image = rsp;
          //       });
          // }
          // if (rsp.status === 200) {
          //   // La respuesta 'rsp.data' contiene la cadena Base64
          //   console.log("imageeeeeeeeeee",rsp.data);
          //   this.image = rsp.data; // Asignamos la cadena Base64 directamente
          // }
        })
        .catch((error) => {
          console.error("Error al obtener la imagen:", error);
        });

      // Llamamos al método para obtener el QR, si es necesario
    },
    async LoadData() {
      if (!this.propPerson) {
        return;
      }

      const normalizedPropPerson = await this.hydratePersonFromDocument(this.propPerson);
      await this.applyLoadedPerson(normalizedPropPerson);
    },
    Limit() {
      // console.log("Limit",this.person.GenPerson.TypePersonDocument)  ;
    },
    updateDataDistrict() {

      if (this.person != null)
        if (this.person.GenPerson != null)
          if (this.person.GenPerson.Addresses != null)
            if (this.person.GenPerson.Addresses.length > 0) {
              this.DistrictUbigeo = this.person.GenPerson.Addresses[0].PadCodeUbigeo;
            }
    },
    txtDocument() {
      if (this.typeperson == 1) {
        this.$refs.textNtpName.focus();
        // if(this.person.GenPerson.PrsDocumentNumber)
        this.search();
      } else this.$refs.textJrpName.focus();
    },
    inputDocument(valor) {
      this.fingers.forEach((finger) => {
        finger.isActive = false;
      });
      // console.log("escribienod", valor);
      if (valor.length > 7) {
        this.GetFingerPrintListBy();
      }
    },
    async search() {
      this.clearDetails();
      //this.clear();
      // console.log("Persona11111",this.person);
      try {
        let obj = {
          TypePerson: this.TypePersonDocument.DedValue || 1,
          PrsDocumentNumber: this.person.GenPerson.PrsDocumentNumber,
          UsrID: this.$fun.getUserID(),
          IsValidation: 0,
        };

        const response = await Service.personatusearch(obj, this.$fun.getUserID());

        if (response.status == 200 && response.data) {
          this.personEdit = await this.hydratePersonFromDocument(
            this.normalizePersonIds(response.data)
          );
          await this.applyLoadedPerson(this.personEdit);
          //console.log("PersonaEdit111111", this.personEdit);

          const responseAdm = await _sAdmonition.adminitionByNtpID(
            this.personEdit.NtpID,
            this.$fun.getUserID()
          );

          if (responseAdm.status == 200 && responseAdm.data) {
            let Admonition = responseAdm.data;
            //console.log("Admonition", Admonition);

            this.TypeAdmonitionName = Admonition.TypeAdmonitionName;

            this.person.NtpName = this.personEdit.NtpName;
            this.person.NtpMaternalSurname = this.personEdit.NtpMaternalSurname;
            this.person.NtpPaternalSurname = this.personEdit.NtpPaternalSurname;
            this.validateContractRequirements(true);
          } else {
            this.editing = true;
            this.validateContractRequirements(true);
          }

          // Cerrar el diálogo de agregar persona
          //this.dialogAddPerson = false;

          // Esperar un momento para que Vue actualice el DOM
          // this.$nextTick(() => {
          //   // Abrir el diálogo de editar persona
          //   this.dialogEditPerson = true;
          // });
        } else {
          //this.$toast.warning("DNI no encontrado, puedes registrarlo.");
          this.personEdit = {};
          this.clear();
          this.validateContractRequirements(true);
        }
      } catch (error) {
        console.error("Error al buscar persona:", error);
        this.$toast.error("Error en la búsqueda.");
      }
      // Service.getNaturalPerson(this.person.GenPerson.PrsDocumentNumber, this.$fun.getUserID()).then((r) => {
      //   if (r.status == 200) {
      //     this.editing = true;
      //     this.personEdit = r.data;
      //     // if (this.personEdit != null) {
      //     //   if (this.personEdit.GenPerson != null) {
      //     //     this.person = { ...this.personEdit };
      //     //     this.person.NtpBirthDate = this.$moment(this.personEdit.NtpBirthDate).format("DD-MM-YYYY");
      //     //     this.person.NtpBirthDate = this.personEdit.NtpBirthDate;
      //     //     this.person.GenPerson.TypePersonDocument = 1;

      //     //     if (this.person.GenPerson.Emails.length > 0) {
      //     //       this.email = this.person.GenPerson.Emails[0];
      //     //     }
      //     //     if (this.person.GenPerson.Telephones.length > 0) {
      //     //       this.phone = this.person.GenPerson.Telephones[0];
      //     //     }
      //     //     if (this.person.GenPerson.Addresses.length > 0) {
      //     //       this.ZoneID = this.person.GenPerson.Addresses[0].ZonID;
      //     //       this.address = this.person.GenPerson.Addresses[0];
      //     //       this.DepartmentUbigeo = this.person.GenPerson.Addresses[0].PadCodeUbigeo.substr(0, 2);
      //     //       this.ProvinceUbigeo = this.person.GenPerson.Addresses[0].PadCodeUbigeo.substr(0, 4);
      //     //       this.DistrictUbigeo = this.person.GenPerson.Addresses[0].PadCodeUbigeo;
      //     //     }
      //     //     if (this.person.GenNaturalPersonDriver.length > 0) {
      //     //       this.driver = this.person.GenNaturalPersonDriver[0];
      //     //     }
      //     //   } else if (this.propPerson.PrsDocumentNumber) this.person.GenPerson.PrsDocumentNumber = this.propPerson.PrsDocumentNumber;

      //     //   if (this.typeperson == 1) this.$refs.textNtpName.focus();
      //     //   else this.$refs.textJrpName.focus();
      //     // }
      //     // this.editing = false;
      //   }
      //   this.$emit("search", this.person);
      // });
    },
    uploadFile() {
      var formData = new FormData();
      let i = 0;

      formData.append(i.toString(), this.Attach);
      i++;

      console.log("FormData: " + formData);
      _sGeneral.uploadfile("123", this.$fun.getUserID(), formData, 3);
      //this.$fun.alert("Guardado Correctamente", "success");
      //this.$emit("onClose");
    },

    openFile(url) {
      _sGeneral.download(url.name, this.$fun.getUserID()).then((r) => {
        if (r.status === 200) {
          this.$fun.downloadHttp(r.data, url.name);
        }
      });
    },
    validateFile() {
      if (!this.Attach) return;
      if (!this.formats_accepted.includes(this.Attach.type)) {
        this.$fun.alert("Formato de archivo anexo no permitido", "warning");
        return;
      }
      if (this.Attach.size > this.max_size) {
        this.$fun.alert("Tamaño de archivo excede el límite permitido (3MB)", "warning");
        return;
      }
    },
    saveFile() {
      console.log("Nombre del Archivo: ", this.Attach);

      this.validateFile();
      // s_HarvestSchedule
      //   .uploadFileName(
      //     this.selected.HvsID,
      //     this.Attach.name,
      //     this.$fun.getUserID()
      //   )
      //   .then((r) => {
      //     if (r.status === 200) {
      // console.log("Subido Correcto");
      this.uploadFile();
      //   }
      // });
    },
    clear() {
      this.clearDetails();
      this.ZoneID = 15;
      this.DepartmentUbigeo = "20";
      this.ProvinceUbigeo = "2001";
      this.phone = {
        TypePhone: 1,
        PpnNumberPhone: "",
        PpnIsDefault: 1,
      };
      this.address = {
        PadCodeUbigeo: "",
        PadAddress: "",
        PadAddressReference: "",
        PadStreet: "",
        PadDepartment: "",
        ZonID: 0,
        PadIsDefault: 1,
      };
      this.email = {
        PemEmail: "",
        PemIsDefault: 1,
      };
      this.driver = {
        NpdID: 0,
        NpdDocumentNumber: "",
        NpdDocumentInit: null,
        NpdDocumentEnd: null,
        TypeDocumentCategory: 0,
      };

      let doc;
      if (this.person.GenPerson.PrsDocumentNumber.length > 0)
        doc = this.person.GenPerson.PrsDocumentNumber;
      else doc = "";
      this.person = {
        NtpName: "",
        NtpPaternalSurname: "",
        NtpMaternalSurname: "",
        NtpID: 0,
        NtpBirthDate: this.$moment().format(this.$const.DateMomentFormat),
        TypeSex: 1,
        GenPerson: {
          TypePersonDocument: 1,
          PrsDocumentNumber: doc,
          NatID: 193,
        },
      };
    },
    validateData() {
      if (!this.validateContractRequirements()) {
        return false;
      }

      if (this.driver) {
        if (this.driver.NpdDocumentNumber.length > 0) {
          if (
            this.driver.TypeDocumentCategory == 0 ||
            this.driver.TypeDocumentCategory == null
          ) {
            this.$fun.alert("Seleccione Categoría", "warning");
            return false;
          }

          if (!this.$fun.isValidDate(this.driver.NpdDocumentEnd)) {
            this.$fun.alert("Seleccione Fecha de Revalidación", "warning");
            return false;
          }
          if (
            !this.$fun.isValidRangeDate(
              this.driver.NpdDocumentInit,
              this.driver.NpdDocumentEnd
            )
          ) {
            this.$fun.alert("Verifique Fechas de Validez", "warning");
            return false;
          }
        }
      }

      return true;
    },
    clearDetails() {
      this.addressDetail = [];
      this.phonesDetail = [];
      this.emailsDetail = [];
      this.image = null;
      if (this.fingers) {
        this.fingers.forEach((finger) => {
          finger.isActive = false;
          finger.Quality = null;
        });
      }
      this.phone = {
        TypePhone: 1,
        PpnNumberPhone: "",
        PpnIsDefault: 1,
      };
      this.address = {
        PadCodeUbigeo: "",
        PadAddress: "",
        PadAddressReference: "",
        PadStreet: "",
        PadDepartment: "",
        ZonID: 0,
        PadIsDefault: 1,
      };
      this.email = {
        PemEmail: "",
        PemIsDefault: 1,
      };
      this.driver = {
        NpdID: 0,
        NpdDocumentNumber: "",
        NpdDocumentInit: null,
        NpdDocumentEnd: null,
        TypeDocumentCategory: 0,
      };
    },
    save() {
      if (this.phone.PpnNumberPhone && this.phone.PpnNumberPhone.trim()) {
        if (this.validateDetail(1)) {
          this.addItemDetail(1);
        } else {
          return Promise.resolve(false);
        }
      }
      if (this.email.PemEmail && this.email.PemEmail.trim()) {
        if (this.validateDetail(2)) {
          this.addItemDetail(2);
        } else {
          return Promise.resolve(false);
        }
      }

      if (!this.validateData()) {
        return Promise.resolve(false);
      }

      const prsID = this.getResolvedPrsID();
      this.person.PrsID = prsID;
      this.person.GenPerson.PrsID = prsID;

      this.person.GenPerson.TypePerson = this.typeperson;
      this.person.GenPerson.TypePersonDocument = this.TypePersonDocument.DedValue;
      this.person.GenPerson.NatID = this.person.NatID;

      this.person.GenPerson.PrsDocumentNumber = this.person.GenPerson.PrsDocumentNumber;
      this.person.NtpName = this.person.NtpName.toUpperCase().trim();
      this.person.NtpPaternalSurname = this.person.NtpPaternalSurname.toUpperCase().trim();
      this.person.NtpMaternalSurname = this.person.NtpMaternalSurname.toUpperCase().trim();

      this.person.GenPerson.Telephones = this.phonesDetail;
      this.person.GenPerson.Emails = this.emailsDetail;
      this.person.GenPerson.Addresses = this.addressDetail;
      this.person.GenPerson.Majors = this.majorsDetail;
      this.person.Majors = this.majorsDetail;
      this.person.GenPerson.SecStatus = 1;
      this.person.SecStatus = 1;
      this.person.NtpDisability = this.person.NtpDisability ? 1 : 0;
      this.person.NtpSyndical = this.person.NtpSyndical ? 1 : 0;

      this.person.NtpAttach = this.Attach?.name || "";

      let p = { ...this.person };

      if (this.driver) {
        if (this.driver.NpdDocumentNumber.length > 0) {
          this.driver.SecStatus = 1;
          this.driver.NtpID = p.NtpID;
          this.driver.UsrCreateID = this.driver.UsrCreateID;
          this.driver.UsrUpdateID = this.$fun.getUserID();
          p.GenNaturalPersonDriver = [this.driver];
          // p.GenNaturalPersonDriver = this.driver;
        } else {
          // this.$fun.alert("Verificar campo Brevete no puede ser vacio", "warning");
          // return;
          // if (this.driver.NpdID > 0) {
          //   this.driver.SecStatus = 0;
          //   this.driver.NtpID = p.NtpID;
          //   p.GenNaturalPersonDriver = [this.driver];
          //   // p.GenNaturalPersonDriver = this.driver;
          // }
        }
      }
      const fingerprints = this.capturedFingerprints.filter((fp) => fp !== null);
      const documentNumber = this.person.GenPerson.PrsDocumentNumber;
      //_sContracthmRs.SaveFingerprints(fingerprints, this.$fun.getUserID());
      //console.log("Fingerprints", fingerprints);
      //console.log("Persona", p);
      return Service.savenaturalperson(p, this.$fun.getUserID()).then(async (r) => {
        const personID = r.data.usrID;
        const fingerprintsWithPersonID = fingerprints.map((fp) => ({
          ...fp, // Mantiene todas las propiedades existentes
          NtpID: personID, // Agrega el ID de la persona
        }));

        return _sContracthmRs
          .SaveFingerprints(fingerprintsWithPersonID, this.$fun.getUserID())
          .then(async () => {
            if (this.Attach?.size) {
              this.saveFile();
            }
            //console.log("Image",this.image)
            // if(this.image){
            //   this.uploadImage(this.image);
            // }
            const savedPerson = await this.hydratePersonFromDocument({
              PrsDocumentNumber: documentNumber,
              GenPerson: {
                PrsDocumentNumber: documentNumber,
              },
            });

            if (savedPerson) {
              await this.applyLoadedPerson(savedPerson);
            }

            const emittedPerson = savedPerson || this.person;

            this.$emit("personSaved", emittedPerson);
            this.$emit("save", emittedPerson);
            // this.person.GenPerson.PrsDocumentNumber = "";
            // this.clear();
            this.$fun.alert("Guardado Correctamente", "success");
            this.closeSave();
            return emittedPerson;
          })
          .catch((error) => {
            console.error("Error al guardar:", error);
            this.$fun.alert("Error al guardar" + error, "error");
            throw error;
          });
        // if (this.Attach) {
        //   this.saveFile();
        // }
        // this.$emit("personSaved", this.person);
        // this.$emit("save", this.person);
        // this.person.GenPerson.PrsDocumentNumber = "";
        // this.clear();
        // this.$fun.alert("Guardado Correctamente", "success");
        // this.closeSave();
      });
    },
    openEducationModal() {
      this.isEditingEducation = false;
      this.educationItem = {
        PmaID: 0,
        LveID: null,
        EdiCode: null,
        EdiName: "",
        EdmCode: null,
        EdmName: "",
        PmaYearAdmission: null,
        PmaYearGraduation: null,
        PmaIsDefault: 0
      };
      this.educationDialog = true;
    },
    closeEducationModal() {
      this.educationDialog = false;
    },
    onInstitutionChange(val) {
      this.educationItem.EdiCode = val;
      this.educationItem.EdmCode = null;
    },
    async saveEducationItem() {
      const item = this.educationItem;
      if (!item.LveID) {
        this.$fun.alert("El nivel educativo es obligatorio", "warning");
        return;
      }
      
      const level = parseInt(item.LveID);
      if (level >= 8) {
        if (!item.EdiCode) {
          this.$fun.alert("El Centro de Estudios / Universidad es obligatorio", "warning");
          return;
        }
        if (!item.EdmCode) {
          this.$fun.alert("La Carrera es obligatoria", "warning");
          return;
        }
      } else {
        item.EdiCode = "";
        item.EdiName = "";
        item.EdmCode = "";
        item.EdmName = "";
      }

      // Resolve display names from loaded selector items
      try {
        const levelItems = this.$refs.educLevelRef?.$refs?.sgeneric?.items || [];
        const levelItem = levelItems.find(x => x.DedValue == item.LveID);
        item.LveName = levelItem ? levelItem.DedDescription : `NIVEL ${level}`;
      } catch (e) {
        item.LveName = `NIVEL ${level}`;
      }

      if (level >= 8) {
        try {
          const instItems = this.$refs.educInstitutionRef?.$refs?.sgeneric?.items || [];
          const instItem = instItems.find(x => x.EdiCode == item.EdiCode);
          item.EdiName = instItem ? instItem.EdiDescription : "";
        } catch (e) {
          item.EdiName = "";
        }
        try {
          const majorItems = this.$refs.educMajorRef?.$refs?.sgeneric?.items || [];
          const majorItem = majorItems.find(x => x.EdmCode == item.EdmCode);
          item.EdmName = majorItem ? majorItem.EdmDescription : "";
        } catch (e) {
          item.EdmName = "";
        }
      }

      // Mark default if it is the first study record added
      const activeMajors = this.majorsDetail.filter(x => x.SecStatus === 1);
      if (activeMajors.length === 0) {
        item.PmaIsDefault = 1;
      }

      if (this.isEditingEducation) {
        // Find by local reference or index
        const idx = this.majorsDetail.findIndex(x => x === this._selectedMajorRef);
        if (idx !== -1) {
          this.majorsDetail.splice(idx, 1, { ...item });
        }
      } else {
        this.majorsDetail.push({
          ...item,
          PmaID: 0,
          PrsID: this.person.PrsID || 0,
          SecStatus: 1,
          UsrCreateID: this.$fun.getUserID()
        });
      }

      this.closeEducationModal();
    },
    editEducation(item) {
      this._selectedMajorRef = item;
      this.educationItem = { ...item };
      this.isEditingEducation = true;
      this.educationDialog = true;
    },
    deleteEducation(item) {
      this.$fun.alert("¿Está seguro de eliminar este estudio?", "question").then((resp) => {
        if (resp.value) {
          item.SecStatus = 0;
        }
      });
    },
    setEducationPrincipal(item) {
      this.majorsDetail.forEach(x => {
        x.PmaIsDefault = (x === item) ? 1 : 0;
      });
    },

    closeSave() {
      this.fingers.forEach((finger) => {
        finger.isActive = false;
      });
      this.$emit("toclose", 2);
      // this.clear();
    },

    close() {
      //this.$refs.document.focus();
      this.$fun.alertFull("¿Está seguro de Salir?", "question").then((resp) => {
        if (resp.value) {
          this.fingers.forEach((finger) => {
            finger.isActive = false;
          });
          this.$emit("toclose", 2);
          this.clear();
        }
      });
    },
    closeAll() {
      this.$refs.document.focus();
      this.fingers.forEach((finger) => {
        finger.isActive = false;
      });
      this.$emit("toclose", 2);
      this.clear();
      this.$fun.alertFull("¿Está seguro de Salir?", "question").then((resp) => {
        if (resp.value) {
          let obj = {
            WftID: 4,
            DNI: this.person.GenPerson.PrsDocumentNumber,
            WftStatus: 0,
            SecStatus: 0,
            WfpTypeFinger: 0,
            UsrCreateID: this.$fun.getUserID(),
            NtpValue: "",
            // this.ipMatch[1]
          };
          _sContracthmRs.saveFingerTemp(obj, this.$fun.getUserID()).then((r) => { });
          this.$refs.document.focus();
          this.fingers.forEach((finger) => {
            finger.isActive = false;
          });
          this.$emit("toclose", 2);
          this.clear();
        }
      });
    },
    handleRightClick(event, index) {
      // Only show menu for active fingerprints
      if (this.fingers[index].isActive) {
        this.selectedFingerDelete = index;
        this.selectedFingerActive = true;
        this.showContextMenu = true;
        this.menuX = event.clientX;
        this.menuY = event.clientY;
      } else {
        this.selectedFingerActive = false;
      }
    },
    deleteFingerprint() {
      if (
        this.selectedFingerDelete !== null &&
        this.fingers[this.selectedFingerDelete].isActive
      ) {
        // Buscar la huella en dataFingerL (guardadas en BD)
        const fingerprintToDelete = this.dataFingerL.find(
          (item) => item.WfpTypeFinger === this.fingers[this.selectedFingerDelete].id
        );

        if (fingerprintToDelete) {
          // Si está en la base de datos, marcarla para eliminación
          fingerprintToDelete.SecStatus = 0;

          // Si existe en capturedFingerprints, actualizar estado
          if (this.capturedFingerprints[this.selectedFingerDelete]) {
            this.capturedFingerprints[this.selectedFingerDelete].SecStatus = 0;
          } else {
            this.capturedFingerprints[this.selectedFingerDelete] = {
              Dni: this.person.GenPerson.PrsDocumentNumber,
              WfpTypeFinger: this.selectedFingerDelete,
              usrCreateID: this.$fun.getUserID(),
              SecStatus: 0,
            };

            if (fingerprintToDelete.WfpID) {
              this.capturedFingerprints[this.selectedFingerDelete].WfpID =
                fingerprintToDelete.WfpID;
            }
          }
        } else if (this.capturedFingerprints[this.selectedFingerDelete]) {
          // Si solo existe en capturedFingerprints (temporal), eliminarla
          delete this.capturedFingerprints[this.selectedFingerDelete];
        }

        // Actualizar UI - Cambiar apariencia del dedo
        this.fingers[this.selectedFingerDelete].isActive = false;

        // Cerrar el menú contextual si aplica
        this.showContextMenu = false;

        // Mostrar confirmación al usuario
        this.$fun.alert("Huella eliminada o marcada para eliminación", "success");
      }
    },
  },
  computed: {
    filteredAddressDetail() {
      // Filtrar los elementos donde SecStatus sea 1
      return this.addressDetail
        ? this.addressDetail.filter((item) => item.SecStatus === 1)
        : [];
    },
    filteredPhonesDetail() {
      return this.phonesDetail
        ? this.phonesDetail.filter((item) => item.SecStatus === 1)
        : [];
    },
    filteredEmailsDetail() {
      return this.emailsDetail
        ? this.emailsDetail.filter((item) => item.SecStatus === 1)
        : [];
    },
    requiresInstitutionAndMajor() {
      return this.educationItem && this.educationItem.LveID && parseInt(this.educationItem.LveID) >= 8;
    },
    filteredMajorsDetail() {
      return this.majorsDetail
        ? this.majorsDetail.filter((item) => item.SecStatus === 1)
        : [];
    },
    // formTitle () {
    //   //return this.editedIndex === -1 ? 'Nuevo' : 'Editar'
    // },
  },
  watch: {
    propPerson: {
      handler(newVal) {
        if (newVal) {
          this.LoadData(); // Ya tienes este método para cargar datos
        }
      },
      immediate: true,
    },

    DepartmentUbigeo(newVal) {
      console.log("DepartmentUbigeo1111", newVal);
      if (this.isInitializing) return;
      this.ProvinceUbigeo = "01";
      this.configProvince = {
        title: "Provincia",
        url: _sGeneric.getProvince(),
        params: {
          requestID: this.$fun.getUserID(),
          DepartmentUbigeo: newVal,
          SearchText: "",
        },
      };
      // Opcional: resetear distrito y zonas si lo necesitas
      this.DistrictUbigeo = "01";
      this.configDistrict = null;
    },
    ProvinceUbigeo(newVal) {
      console.log("ProvinceUbigeo2222", newVal);

      if (this.isInitializing) return;
      this.DistrictUbigeo = "01";
      if (newVal !== "0") {
        this.configDistrict = {
          title: "Distrito",
          url: _sGeneric.getDistrict(),
          params: {
            requestID: this.$fun.getUserID(),
            DistrictUbigeo: this.DepartmentUbigeo.toString() + newVal.toString(),
            SearchText: "",
          },
        };
      }
    },
    DistrictUbigeo() {
      // console.log("DistrictUbigeo3333",this.DistrictUbigeo);
      // if(this.editItemAddress){ this.DistrictUbigeo = this.address.PadCodeUbigeo.substr(4, 2); }
    },

    "phone.TypePhone"() {
      this.maxlengthPhone1 = parseInt(
        this.$refs.TypePhoneRef.items.find((x) => x.DedValue === this.phone.TypePhone)
          .DedHelper2
      );
    },

    "phone2.TypePhone"() {
      this.maxlengthPhone2 = parseInt(
        this.$refs.TypePhoneRef2.items.find((x) => x.DedValue === this.phone2.TypePhone)
          .DedHelper2
      );
    },
  },
  created() {
    //if (this.full) {
    this.configNationality = {
      title: "Nacionalidad",
      url: _sGeneric.getNationality(),
      params: { requestID: this.$fun.getUserID() },
    };
    this.configDepartment = {
      title: "Departamento",
      url: _sGeneric.getDepartment(),
      params: { requestID: this.$fun.getUserID() },
    };

    this.configProvince = {
      title: "Provincia",
      url: _sGeneric.getProvince(),
      params: {
        requestID: this.$fun.getUserID(),
        DepartmentUbigeo: '01',
        SearchText: "",
      },
    };

    this.configDistrict = {
      title: "Distrito",
      url: _sGeneric.getDistrict(),
      params: {
        requestID: this.$fun.getUserID(),
        DistrictUbigeo: "01",
        SearchText: "",
      },
    };

    this.configZones = {
      title: "Zonas",
      url: _sGeneric.getZones(),
      params: { requestID: this.$fun.getUserID() },
    };
    // console.log("Distrito",this.configDistrict);
    this.updateUbigeo(this.DistrictUbigeo);
    this.DepartmentUbigeo = "20";
    if (this.propPerson != null) {
      this.getParam().then(() => {
        this.LoadData();
      });

    }
  },
  mounted() {
    // await this.getParam();
    // this.LoadData();
    // const rtc = new RTCPeerConnection();
    // rtc.createDataChannel("");
    // rtc.createOffer().then((offer) => rtc.setLocalDescription(offer));
    // rtc.onicecandidate = (event) => {
    //   if (event && event.candidate) {
    //      this.ipMatch = /([0-9]{1,3}(\.[0-9]{1,3}){3})/.exec(event.candidate.candidate);
    //     if (this.ipMatch) {
    //       console.log("Local IP:", this.ipMatch[1]);
    //     }
    //   }};
    // console.log("mounted",this.person.GenPerson.TypePersonDocument);
    // let recaptchaScript = document.createElement("script");
    // recaptchaScript.setAttribute("src", this.$const.URL + "/signalr/hubs");
    // document.head.appendChild(recaptchaScript);
    // recaptchaScript.addEventListener("load", () => {
    // 	$.connection.hub.url = this.$const.URL + "/signalr";
    // 	var chat = $.connection.notification;
    // 	chat.client.SendMessageTagfingerprint = group => {
    //     this.captured = true;
    //     this.scanning = false;
    //     this.statusOpen=false;
    //     setTimeout(() => {
    //             this.showModal = false;
    //         }, 1000);
    //         this.GetFingerPrintListBy();
    // 	};
    // 	$.connection.hub.start({ jsonp: true }).done(e => {
    // 		chat.invoke("addToGroup", "fingerprintData");
    // 	});
    // });
  },
  beforeDestroy() {
    this.closeCamera();
  },
};
</script>
<style scoped>
.person-form {
  max-width: 1200px;
  margin: 0 auto;
}

.personal-data-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 24px;
}

.photo-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  padding: 16px;
}

.photo-container {
  border: 3px dashed #ccc;
  border-radius: 12px;
  padding: 8px;
  background: white;
}

.photo-preview {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.finger-point:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.fingerprint-scanner {
  position: relative;
}

.fingerprint-icon {
  position: relative;
  overflow: hidden;
}

.scanning-animation {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

/* Estilos adicionales para mejorar la apariencia */
.v-tab {
  text-transform: none !important;
  font-weight: 500;
}

.v-card--outlined {
  border: 1px solid #e0e0e0 !important;
}

/* Animaciones para el scanner de huellas */
.scanner-container {
  position: relative;
  display: inline-block;
}

.scanner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.scanner-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, transparent, #ff6b35, transparent);
  animation: scan 2s ease-in-out infinite;
}

@keyframes scan {
  0% {
    top: 0;
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }

  100% {
    top: calc(100% - 3px);
    opacity: 1;
  }
}

.captured-container {
  position: relative;
  display: inline-block;
}

.captured-fingerprint {
  max-width: 150px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border: 3px solid #4caf50;
}

.success-icon {
  position: absolute;
  top: -10px;
  right: -10px;
  background: white;
  border-radius: 50%;
}

.waiting-container {
  padding: 30px;
}

/* Efectos de hover mejorados */
.v-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Mejorar el aspecto de los campos de formulario */
.v-text-field--outlined .v-input__control .v-input__slot {
  min-height: 40px;
}

.v-text-field--dense .v-input__control .v-input__slot {
  min-height: 36px;
}

/* Estilo para los chips */
.v-chip.v-size--small {
  font-size: 0.75rem;
  font-weight: 500;
}

/* Espaciado consistente */
.ga-2>*:not(:last-child) {
  margin-bottom: 8px;
}

/* Responsive mejoras */
@media (max-width: 600px) {
  .photo-preview {
    width: 150px !important;
    height: 180px !important;
  }

  .photo-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

/* Mejorar la apariencia de los switches */
.v-input--switch .v-input__slot {
  margin: 0;
}

.v-input--switch .v-label {
  margin-left: 8px;
}

.v-menu__content {
  z-index: 2000 !important;
  /* Asegura que el menú esté por encima de otros elementos */
}

.v-list-item {
  cursor: pointer;
  /* Cambia el cursor para indicar que es clickeable */
}

.v-list-item:hover {
  background-color: #f5f5f5;
  /* Cambia el color de fondo al pasar el mouse */
}

.v-list-item--active {
  background-color: #e0e0e0;
  /* Color de fondo para el elemento activo */
}

.v-list-item--active:hover {
  background-color: #d5d5d5;
  /* Color de fondo al pasar el mouse sobre el elemento activo */
}

.v-list-item__title {
  font-size: 14px;
  /* Tamaño de fuente para el título */
}

.v-list-item__subtitle {
  font-size: 12px;
  /* Tamaño de fuente para el subtítulo */
  color: #666;
  /* Color más claro para el subtítulo */
}
</style>
